import Contracts from './List'
import Contract from './Contract'

export { Contract }

export default Contracts
